// extracted by mini-css-extract-plugin
export var actionButton = "_8f-1";
export var actionButtons = "_8f-2";
export var actions = "_8f-0";
export var aiUnread = "_8f-10";
export var alignCenter = "_8f-h";
export var backWrapper = "_8f-3";
export var cellContainer = "_8f-4";
export var checkboxContainer = "_8f-5";
export var contentContainer = "_8f-6";
export var contentHeader = "_8f-8";
export var conversationsTableWrapper = "_8f-s";
export var draftReplyBadgeContainer = "_8f-m";
export var dropdownItem = "_8f-b";
export var dropdownItemsContainer = "_8f-a";
export var dropdownTitle = "_8f-c";
export var errorIcon = "_8f-7";
export var filter = "_8f-d";
export var gray = "_8f-i";
export var headerActionButtons = "_8f-e";
export var headerCheckboxContainer = "_8f-f";
export var icon = "_8f-j";
export var menuContainer = "_8f-k";
export var noMoreTicketsIcon = "_8f-12";
export var noMoreTicketsSubText = "_8f-13";
export var oneLine = "_8f-l";
export var optionsButton = "_8f-n";
export var plus = "_8f-o";
export var portalButtonsWrapper = "_8f-g";
export var red = "_8f-p";
export var scrolledTop = "_8f-9";
export var search = "_8f-q";
export var selectedConversationsCount = "_8f-r";
export var spinner = "_8f-t";
export var strong = "_8f-u";
export var summaryCell = "_8f-v";
export var tableContainer = "_8f-11";
export var tagContainer = "_8f-w";
export var threeDots = "_8f-x";
export var twoLines = "_8f-y";
export var unread = "_8f-z";